import { render } from "./DriveFolder.vue?vue&type=template&id=07dd9d28&scoped=true&ts=true"
import script from "./DriveFolder.vue?vue&type=script&lang=ts"
export * from "./DriveFolder.vue?vue&type=script&lang=ts"

import "./DriveFolder.vue?vue&type=style&index=0&id=07dd9d28&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dd9d28"]])

export default __exports__